@if (skillSetSpec$ | async; as spec) {
  <div class="layout-col full gap-xl">
    <div class="layout-row place-start-center gap-md">
      <!-- TODO save button is not disabled if validation fails -->
      <mat-form-field>
        <mat-label>{{ 'context.name' | translate }}</mat-label>
        <input
          matInput
          name="name"
          type="text"
          required
          placeholder="{{ 'context.name' | translate }}"
          [(ngModel)]="spec.name"
          #idModel="ngModel"
        />
        <mat-error elderValidationError></mat-error>
      </mat-form-field>
      <mat-checkbox name="singular" [(ngModel)]="spec.singular" [labelPosition]="'after'">
        {{ 'skillSets.singular' | translate }}
      </mat-checkbox>
      <mat-checkbox name="required" [(ngModel)]="spec.required" [labelPosition]="'after'">
        {{ 'skillSets.required' | translate }}
      </mat-checkbox>
    </div>
    <div class="flex layout-row gap-xl">
      <mat-tab-group class="flex" animationDuration="0ms">
        <!-- Tab conditions -->
        <mat-tab>
          <ng-template mat-tab-label>
            <span
              class="noselect"
              [matBadge]="spec?.conditions?.length?.toString()"
              [matBadgeHidden]="!spec?.conditions?.length"
              [matBadgeOverlap]="false"
              >{{ 'skillSets.conditions.title' | translate }}
            </span>
          </ng-template>
          <app-constraint-spec-table class="flex" [(constraints)]="spec.conditions">
          </app-constraint-spec-table>
        </mat-tab>
        <!-- Tab Constraints -->
        <mat-tab>
          <ng-template mat-tab-label>
            <span
              class="noselect"
              [matBadge]="spec?.constraints?.length?.toString()"
              [matBadgeHidden]="!spec?.constraints?.length"
              [matBadgeOverlap]="false"
              >{{ 'skillSets.constraints.title' | translate }}
            </span>
          </ng-template>
          <app-constraint-spec-table class="flex" [(constraints)]="spec.constraints">
          </app-constraint-spec-table>
        </mat-tab>
        <!-- Tab Capacities -->
        <mat-tab>
          <ng-template mat-tab-label>
            <span
              class="noselect"
              [matBadge]="spec?.capacities?.length?.toString()"
              [matBadgeHidden]="!spec?.capacities?.length"
              [matBadgeOverlap]="false"
              >{{ 'skillSets.capacities.title' | translate }}
            </span>
          </ng-template>
          <app-processing-time-spec-table class="flex" [(variantSets)]="spec.capacities">
          </app-processing-time-spec-table>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
}
